import React, { forwardRef } from "react";
import cn from "classnames";

import { RegularText, MediumText } from "components/Text";

import styles from "./styles.module.scss";

/**
 * Единый инпут с опциональным лейблом и выводом ошибки.
 * labelPosition: left | top
 */
export const Input = forwardRef(function Input(
  {
    label,
    labelVariant = "medium",
    labelPosition = "left",
    labelWidth,
    error,
    className,
    containerClassName,
    inputWidth,
    type = "text",
    ...rest
  },
  ref
) {
  const LabelComponent = labelVariant === "regular" ? RegularText : MediumText;

  return (
    <div
      className={cn(
        styles.container,
        labelPosition === "top" ? styles.vertical : styles.horizontal,
        containerClassName
      )}
    >
      {!!label && (
        <LabelComponent
          className={styles.label}
          style={labelWidth ? { width: labelWidth, flexShrink: 0 } : undefined}
        >
          {String(label).replace(/:$/, "")}:
        </LabelComponent>
      )}
      <div className={styles.inputWrapper} style={{ width: inputWidth }}>
        <input
          ref={ref}
          type={type}
          className={cn(styles.input, className, {
            [styles.errorBorder]: !!error,
          })}
          {...rest}
        />
        {!!error && typeof error === "string" && (
          <span className={styles.errorText}>{error}</span>
        )}
      </div>
    </div>
  );
});
